/**
 * Returns a cookie by name.
 *
 * @param {String} name
 * @returns {String}
 */
export function getCookie(name) {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const key = `${name}=`;
    let cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }

    if (cookie.indexOf(key) === 0) {
      return cookie.substring(key.length, cookie.length);
    }
  }

  return null;
}

/**
 * Creates a new cookie.
 *
 * @param {String} name
 * @param {String} value
 * @param {Number} days
 */
export function setCookie(name, value, days = 1) {
  const date = new Date();

  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  const expires = `; expires=${date.toUTCString()}`;

  document.cookie = `${name}=${value}${expires}; path=/`;
}

/**
 * Deletes a cookie by name.
 *
 * @param {String} name
 */
export function eraseCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export default {
  getCookie,
  setCookie,
  eraseCookie,
};
